const NotFound = () => <div>NotFound</div>


export default NotFound
